import React from "react";
import PropTypes from "prop-types";
import { format_date_reports } from "../../utils";

const ResultDetailsSection = ({ dateCollected, dateReported, doctorName,isVenous }) => (
  <small className="text-muted">
    <div className="d-flex flex-wrap test-subtitle ageo-medium fs-15">
      <div className="d-flex me-3 result-details">
        <div>Date collected: &nbsp;{" "}</div>
        <span className="text-teal fs-15 ageo-bold text-color-for-mhc">
          {format_date_reports(dateCollected)}
        </span>{" "}
      </div>
       <div className="d-flex me-3 result-details">
        <div>Date reported: &nbsp;{" "}</div>
        <span className="text-teal fs-15 ageo-bold text-color-for-mhc">
          {format_date_reports(dateReported)}
        </span>
      </div>
      <div className="d-flex me-3 result-details">
        <div>Sample type: &nbsp;{" "}</div>
        <span className="text-teal fs-15 ageo-bold">
          {isVenous ? "Venous blood" : "Capillary blood"}
        </span>{" "}
      </div>
    </div>
    {/* <div className="d-flex flex-wrap test-subtitle">
      <div className="d-flex result-details">
        <div>Analysed by:&nbsp;{" "}</div>
        <span className="text-teal fs-15 font-weight-bold">
          Dr {doctorName}
        </span>
      </div>
    </div> */}
  </small>
);

ResultDetailsSection.propTypes = {
  dateCollected: PropTypes.string,
  dateReported: PropTypes.string,
  doctorName: PropTypes.string,
};

export default ResultDetailsSection;
